/**
 * Centralized Environment Configuration
 * Connect Source Architecture
 * 
 * Safe accessor for client-side and server-side configuration.
 * Avoids direct unvalidated process.env/import.meta.env calls.
 */

declare const __RAZORPAY_KEY_ID__: string | undefined;
declare const __GA_MEASUREMENT_ID__: string | undefined;
export interface AppConfig {
  readonly appEnv: 'development' | 'staging' | 'production' | 'test';
  readonly appUrl: string;
  readonly apiBaseUrl: string;
  readonly payment: {
    readonly razorpayKeyId?: string;
    readonly stripePublishableKey?: string;
  };
  readonly analytics: {
    readonly gaMeasurementId?: string;
    readonly metaPixelId?: string;
  };
  readonly isProduction: boolean;
  readonly isDevelopment: boolean;
}

function getEnvString(key: string, fallback: string = ''): string {
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key] as string;
  }
  return fallback;
}

export const appConfig: AppConfig = {
  appEnv: (getEnvString('VITE_APP_ENV') || getEnvString('NODE_ENV') || 'development') as AppConfig['appEnv'],
  appUrl: getEnvString('VITE_APP_URL', 'http://localhost:5173'),
  apiBaseUrl: getEnvString('VITE_API_BASE_URL', (typeof window !== 'undefined' && (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost')) ? 'http://127.0.0.1:5001/ai-studio-applet-webapp-9afe5/asia-southeast1/backend/api' : '/api'),
  payment: {
  razorpayKeyId:
    typeof __RAZORPAY_KEY_ID__ !== 'undefined'
      ? __RAZORPAY_KEY_ID__
      : getEnvString('VITE_RAZORPAY_KEY_ID'),
  stripePublishableKey: getEnvString('VITE_STRIPE_PUBLISHABLE_KEY')
},
  analytics: {
    gaMeasurementId:
  typeof __GA_MEASUREMENT_ID__ !== 'undefined'
    ? __GA_MEASUREMENT_ID__
    : getEnvString('VITE_GA_MEASUREMENT_ID'),
    metaPixelId: getEnvString('VITE_META_PIXEL_ID')
  },
  isProduction: getEnvString('NODE_ENV') === 'production',
  isDevelopment: getEnvString('NODE_ENV') !== 'production'
};


